import React from "react";
import DocumentList from "../Components/DocumentCrafting/List/DocumentList";

const DocumentCraftingListPage: React.FC = () => <DocumentList />;

export default DocumentCraftingListPage;
